<script setup>
const props = defineProps({
  subData: {
    type: Array,
    default: () => []
  },
});
</script>

<template>
    <div class="card sub-bar-section pt-1">
        <h5 class="card-title">하위 영역별 정답률 분포</h5>
        <p class="msg-info py-2">
            다음은 AI·디지털 리터러시의 4개 영역에 대한 하위 영역별 평균 백분율을 나타냅니다. 
            각 영역 내에서 우리 학급 학생들이 어떤 하위 영역에 강점과 약점을 보이는지 파악할 수 있습니다.
        </p>
        <div class="charts-grid">
            <div v-for="(group, gIdx) in subData" :key="gIdx" class="chart-box">
                <div class="chart-header"><img v-if="group.icon" :src="group.icon" alt="" class="title-icon" />{{ group.title }}</div>
                
                <div class="chart-body">                   
                    <div class="y-axis">                     
                        <div class="y-labels">                         
                            <span>100%</span><span>80%</span><span>60%</span><span>40%</span><span>20%</span><span>0%</span>
                        </div>                       
                    </div>                    
                    <div class="bars-wrapper">
                        <div class="grid-lines">
                            <div v-for="n in 6" :key="n" class="line"></div>
                        </div>
                        
                        <div class="bars-container">
                            <div v-for="(item, iIdx) in group.items" :key="iIdx" class="bar-item">
                                <div class="bar-track">
                                    <div class="bar-fill" :style="{ height: item.value + '%', backgroundColor: item.color }">
                                    <span class="value-text">
                                      {{ item.value.toFixed(1) }}%
                                    </span>
                                    </div>
                                </div>
                                <p class="item-label">{{ item.label }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.sub-bar-section {
   
  .charts-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: .5rem;
  }
  .chart-box { 
    background: var(--smoe-white);
    padding: 1.5rem;
    border: 1px solid var(--result-ai-border);
    border-radius: .5rem;
    .chart-header {
      text-align: center;
      font-family: var(--smoe-font-visual);    
      font-weight: 600;
      padding: .25rem 0;
      border-top:  2px solid var(--result-ai-primary-100);
      border-bottom: 3px solid var(--result-ai-primary-100);     
      display: flex;
      align-items: center;
      justify-content: center;
      gap: .5rem;
      img { max-width: 2rem; }
    }
    .chart-body {
      height: 308px;
      display: flex;
      padding: 2rem 0 2rem 1.25rem;
      margin-top: 1rem;
      position: relative;
      &::before {
        content: '백분율(%)';
        position: absolute;
        top: 0;
        left: 0;
        font-size: .875rem;  
        font-weight: 600;
        color: var(--result-ai-primary-800);
        display: inline-flex;
        white-space: nowrap;
      }
    }
  }
  .y-axis {
    display: flex;
    width: 40px;
    height: 100%; 
    position: relative;
    .y-labels {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      width: 100%;
      text-align: right;
      padding-right: 8px;    
      line-height: 0;        
      font-size: 1.125rem;  
      font-weight: 600;    
      span { 
        height: 0; 
        line-height: 0; 
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }      
    }   
  }
  .bars-wrapper {
    flex: 1;
    height: 100%;
    position: relative;
    margin-left: 0;

    .grid-lines {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      pointer-events: none;
      .line {border-bottom: 1px dashed #e0e0e0; width: 100%; height: 1px; }
    }
    .bars-container {
      display: flex;
      justify-content: space-around;
      align-items: flex-end;
      height: 100%;
      width: 100%;
      padding: 0 10px;
      position: relative;
      z-index: 1;
      border-bottom: 2px solid var(--result-ai-border);
      .bar-item {
        flex: 1;
        height: 100%; 
        display: flex;
        flex-direction: column;
        justify-content: flex-end; 
        align-items: center;
        position: relative;   
        .bar-track {
          width: 100%;
          height: 100%; 
          display: flex;
          align-items: flex-end;
          justify-content: center;
        }

        .bar-fill {
          width: 36px;
          border-radius: 4px 4px 0 0;
          position: relative; 

          .value-text {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);           
            bottom: calc(100% + 8px); 
            font-size: 14px;
            font-weight: 600;
            white-space: nowrap;   
            text-align: center;
            line-height: 1.2;         
          }
        }
        .item-label {
          position: absolute;
          top: calc(100% + 10px);
          font-size: 16px;   
          text-align: center;
          line-height: 1.3;
          font-weight: 600;
          width: 100%;
          left: 0;
        }
      }
    }
  }
}
</style>